export default __webpack_public_path__ + "static/press_1-887e8938acf2ed346259abccc3c2763d.jpg";